<template>
  <div>
    <PhieuSuaChuaForm />
  </div>
</template>

<script>
import PhieuSuaChuaForm from '../components/organisms/PhieuSuaChuaForm.vue';

export default {
  name: "PhieuSuaChua",
  components: { PhieuSuaChuaForm },
  data() {
    return {
    };
  },

  created() { },

  methods: { },
};
</script>

<style style type="scss" media="print" scoped>
</style>
